import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/de";
import "dayjs/locale/en";

dayjs.extend(utc);
dayjs.extend(timezone);

export { dayjs };

export function fmtTime(isoStr, tz) {
  if (!isoStr) return "";
  try { return dayjs.utc(isoStr).tz(tz || "UTC").format("HH:mm"); }
  catch { return dayjs.utc(isoStr).format("HH:mm"); }
}

export function fmtDateTime(isoStr, tz, lang) {
  if (!isoStr) return "";
  const locale = lang || (typeof document !== "undefined" && document.documentElement.lang) || "en";
  try { return dayjs.utc(isoStr).tz(tz || "UTC").locale(locale).format("DD MMM YYYY, HH:mm"); }
  catch { return dayjs.utc(isoStr).locale(locale).format("DD MMM YYYY, HH:mm"); }
}

// Local day bucket (YYYY-MM-DD) for an ISO timestamp in the given timezone.
export function dayKey(isoStr, tz) {
  return dayjs.utc(isoStr).tz(tz || "UTC").format("YYYY-MM-DD");
}

// "Now" in the given timezone, optionally anchored to a server timestamp.
export function nowInTz(tz, serverIso) {
  const base = serverIso ? dayjs.utc(serverIso) : dayjs.utc();
  return base.tz(tz || "UTC");
}

export function dayLabel(key, tz, lang, t, serverIso) {
  const now = nowInTz(tz, serverIso);
  if (key === now.format("YYYY-MM-DD")) return t("todayHeading");
  if (key === now.add(1, "day").format("YYYY-MM-DD")) return t("tomorrowHeading");
  return dayjs(key).locale(lang || "en").format("ddd, D MMM");
}

// datetime-local helpers (admin edits values as UTC).
export function isoToInput(isoStr) {
  if (!isoStr) return "";
  return dayjs.utc(isoStr).format("YYYY-MM-DDTHH:mm");
}

export function inputToIso(val) {
  if (!val) return null;
  return dayjs.utc(val).toISOString();
}

export function zonedParts(isoStr, tz) {
  if (!isoStr) return { date: "", time: "" };
  const value = dayjs.utc(isoStr).tz(tz || "UTC");
  return { date: value.format("YYYY-MM-DD"), time: value.format("HH:mm") };
}

export function zonedDateTimeToIso(dateValue, timeValue, tz) {
  if (!dateValue || !timeValue) return null;
  const value = dayjs.tz(`${dateValue}T${timeValue}`, tz || "UTC");
  return value.isValid() ? value.utc().toISOString() : null;
}

export function durationMinutes(startIso, endIso) {
  if (!startIso || !endIso) return 0;
  return Math.max(0, dayjs.utc(endIso).diff(dayjs.utc(startIso), "minute"));
}
